import { useState } from 'react';
import { FormControl, FormLabel, Grid, Input, IconButton, Button, Text, useColorModeValue, Stack, useToast, } from '@chakra-ui/react';
import { EditIcon, CheckIcon } from '@chakra-ui/icons';
import axiosInstance from '../../../utils/axiosInstance';  // Import axios instance for API calls

function AccountSettings({ userData, updateUser, isEditable }) {
  // State to track whether we are in edit mode
  const [isEditing, setIsEditing] = useState(false);

  // State to track the input values
  const [formData, setFormData] = useState({
    firstName: userData?.first_name || '',
    lastName: userData?.last_name || '',
    phoneNumber: userData?.phone_number || '',
    email: userData?.email || '',
    price: userData?.price || 55,
    location: userData?.location || '',
    id: userData?.id
  });
  const bgColor = useColorModeValue('white', 'black');
  const textColor = useColorModeValue('black', 'white');
  const headingColor = useColorModeValue('black', 'white');
  const toast = useToast();

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Handle save
  const handleSave = async () => {
    try {
      const backendUrl = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_BACKEND_URL
  : 'http://localhost:8080';
      // Make an API request to save the data
      const response = await axiosInstance.put(`${backendUrl}/user/update/${formData.id}`, formData);  // Adjust the endpoint as necessary
      
      // Update the user data in Main.js via the updateUser function
      //updateUser(response.data);
      // Show success toast
      console.log(response)
      toast({
        title: "Settings updated",
        description: "Your settings have been successfully updated.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      setIsEditing(false); // Exit edit mode after saving
    } catch (error) {
      console.error('Error updating user data:', error);
      // Show failure toast with error message from the Flask app or a fallback
        console.log(error)
        toast({
          title: "Failed to update settings",
          description: error.response.data.message || "An unexpected error occurred. Please try again.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
    }
  };

  // Toggle edit mode for all fields
  const toggleEditMode = () => {
    if (isEditable) {
      setIsEditing(!isEditing);
    }
  };

  return (
    <Grid
      templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
      gap={6}
    >
      <Grid
        templateColumns="1fr auto"
        alignItems="center"
        gridColumn="span 2"
        mb={4}
      >
        <Text fontSize="xl" fontWeight="bold">
          {isEditable ? 'Account Settings' : 'User Account'}
        </Text>
        {/* Disable the edit button if isEditable is false */}
        {isEditable && (
          <IconButton
            aria-label="Edit all fields"
            icon={isEditing ? <CheckIcon /> : <EditIcon />}
            onClick={toggleEditMode}
            ml={2}
            variant="outline"
          />
        )}
      </Grid>
      <Stack spacing={4} as="form" >

      <FormControl id="firstName">
        <FormLabel>First Name</FormLabel>
        {isEditing ? (
          <Input
          focusBorderColor="brand.blue"
          type="text"
          value={formData.firstName}
          onChange={handleChange}
          />
        ) : (
          <Input
          focusBorderColor="brand.light"
          type="text"
          value={formData.firstName}
          isReadOnly
          />
        )}
      </FormControl>

      <FormControl id="lastName">
        <FormLabel>Last Name</FormLabel>
        {isEditing ? (
          <Input
          focusBorderColor="brand.blue"
          type="text"
          value={formData.lastName}
          onChange={handleChange}
          />
        ) : (
          <Input
          focusBorderColor="brand.light"
          type="text"
          value={formData.lastName}
          isReadOnly
          />
        )}
      </FormControl>
      {isEditable && (
        <FormControl id="phoneNumber">
        <FormLabel>Phone Number</FormLabel>
        {isEditing ? (
          <Input
          focusBorderColor="brand.blue"
          type="tel"
          value={formData.phoneNumber}
          onChange={handleChange}
          />
        ) : (
          <Input
          focusBorderColor="brand.light"
          type="text"
          value={formData.phoneNumber}
          isReadOnly
          />
        )}
      </FormControl>
      )}
      {isEditable && (
        <FormControl id="email">
        <FormLabel>Email Address</FormLabel>
        {isEditing ? (
          <Input
          focusBorderColor="brand.blue"
          type="email"
          value={formData.email}
          onChange={handleChange}
          />
        ) : (
          <Input
          focusBorderColor="brand.light"
          type="text"
          value={formData.email}
          isReadOnly
          />
        )}
      </FormControl>
    )}

      <FormControl id="location" gridColumn="span 2">
        <FormLabel>Address</FormLabel>
        {isEditing ? (
          <Input
          focusBorderColor="brand.blue"
          value={formData.location}
          onChange={handleChange}
          w="full"
          />
        ) : (
          <Input
          focusBorderColor="brand.light"
          type="text"
          value={formData.location}
          isReadOnly
          />
        )}
      </FormControl>
      {/*
      <Flex alignItems="center">
      <Text fontWeight="bold" minWidth="120px">Price:</Text>
      <Text color="green.500" fontWeight="bold">${photographer.price}</Text>
      </Flex>*/}
                  {isEditable && (
                    <FormControl id="price">
        <FormLabel>Price</FormLabel>
        {isEditing ? (
          <Input
          focusBorderColor="brand.blue"
          color="green.500"
          _placeholder={{ opacity: 1, color: "green.500" }}
          type="email"
          value={formData.price}
          onChange={handleChange}
          />
        ) : (
          <Input
          focusBorderColor="brand.light"
          color="green.500"
          _placeholder={{ opacity: 1, color: "green.500" }}
          type="text"
          value={'$'+`${formData.price}`}
          isReadOnly
          />
        )}
      </FormControl>
    )}
    </Stack>
      {/* Display Save button only if isEditable and isEditing */}
      {isEditing && isEditable && (
        <Button
        colorScheme="blue"
        mt={4}
          gridColumn="span 2"
          onClick={handleSave}
          bgGradient='linear(to-r, #FF0080, #7928CA)' 
              textColor={'white'}
              _hover={{ bg: 'green.500', bgGradient: 'linear(to-r, red.500, purple.500)' }}
        >
          Save
        </Button>
      )}
    </Grid>
  );
}

export default AccountSettings;
